<template>
  <v-container
    :id="`${displayAsPlural.toLowerCase().replaceAll(' ', '-')}-view`"
    fluid
    tag="section"
  >
    <v-row justify="center">
      <v-col
        cols="12"
        md="12"
      >
        <material-card
          color="primary"
          :icon="appItem.icon"
          :icon-small="true"
        >
          <template #title>
            <v-container class="py-0">
              <v-row>
                <v-col sm="8">
                  <h3>{{ displayAsSingular }}</h3>
                </v-col>
              </v-row>
            </v-container>
          </template>

          <v-form>
            <v-container
              class="py-0 pb-5"
            >
              <v-row
                no-gutters
              >
                <v-col
                  cols="12"
                  class="text-left"
                >
                  <perform-takeoff
                    ref="formPerformTakeoff"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { mapGetters } from 'vuex'
  import PerformTakeoff from '@/components/maintenance/forms/PerformTakeoff'

  export default {
    name: 'TakeoffView',

    components: {
      PerformTakeoff,
    },

    data () {
      return {
        appItem: null,
        displayAsSingular: 'Takeoff',
        displayAsPlural: 'Takeoffs',
      }
    },

    computed: {
      ...mapGetters('app', [
        'getAppItem',
      ]),
    },

    created () {
      this.$store.dispatch('app/refreshSupport')
      this.appItem = this.getAppItem(this.$options.name)
      this.$store.dispatch('user/setPageName', this.$options.name)
    },
  }
</script>
